/* eslint-disable react/prop-types, react/jsx-handler-names */

import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import * as Icons from '@material-ui/icons';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    height: 50,
    // zIndex: 1000,
  },
  input: {
    display: 'flex',
    padding: 0,
    marginLeft: 10,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 20,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
    maxHeight: '250px',
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
  iconButton: {
    marginLeft: 8,
    height: '40px',
  },
});

function NoOptionsMessage(props) {
  return (
    <Typography color='textSecondary' className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          id: 'select-device',
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      style={{
        backgroundColor: props.isDisabled ? 'rgba(224, 224, 224, .4)' : 'transparent',
        marginTop: 5,
      }}
      variant='outlined'
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      key={props.value}
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component='div'
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography color='textSecondary' className={props.selectProps.classes.placeholder} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

// const components = {
//   Control,
//   Menu,
//   NoOptionsMessage,
//   Option,
//   Placeholder,
//   SingleValue,
//   ValueContainer,
// };

class IntegrationReactSelect extends React.Component {
  render() {
    const {
      classes,
      theme,
      value,
      options,
      label,
      assignText,
      displayButton,
      isDisabled,
      isClearable,
      isSeparator,
      isMenuIsOpen,
      maxHeight,
    } = this.props;
    const customMaxHeight = maxHeight ? maxHeight : '250px';
    const selectStyles = {
      input: (base) => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
          height: '32px',
        },
      }),
      menuList: (provided, state) => ({
        ...provided,
        maxHeight: customMaxHeight,
      }),
    };
    const components = isSeparator
      ? {}
      : {
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
        };
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className={`${classes.root}`}>
          <NoSsr>
            <Select
              id='custom-select-device'
              classes={classes}
              styles={selectStyles}
              options={options}
              components={{
                Control,
                Menu,
                NoOptionsMessage,
                Option,
                Placeholder,
                SingleValue,
                ValueContainer,
                ...components,
              }}
              value={value}
              isClearable={isClearable}
              isDisabled={isDisabled}
              onChange={(e) => this.props.handleChange(e)}
              placeholder={label}
              menuIsOpen={isMenuIsOpen}
            />
          </NoSsr>
        </div>

        {displayButton && (
          <Button
            variant='outlined'
            color='primary'
            id='assign'
            className={classes.iconButton}
            onClick={this.props.handleAddDevice}
            disabled={value === null}
          >
            <Icons.ControlPoint /> {assignText}
          </Button>
        )}
      </div>
    );
  }
}

IntegrationReactSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(IntegrationReactSelect);
